import React from 'react';
import { whatsappLink } from '../data/mock';
import { SectionLabel } from './About';

const Contact = () => {
  return (
    <section
      id="contato"
      className="relative overflow-hidden py-32 md:py-44"
      style={{
        backgroundImage:
          'linear-gradient(rgba(11,8,7,0.82), rgba(11,8,7,0.82)), url(https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/i4589k1k_B4487873-F305-4439-B618-330EE37E7C14.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="max-w-3xl mx-auto px-6 text-center fade-up">
        <div className="flex justify-center">
          <SectionLabel>Entre em contato</SectionLabel>
        </div>
        <h2 className="mt-5 font-display text-[44px] sm:text-[60px] md:text-[80px] leading-[1.04] text-cream">
          Agende seu <span className="text-cream/55">horário</span>
        </h2>
        <p className="mt-6 text-cream-soft text-[15px] md:text-[17px] max-w-xl mx-auto leading-relaxed">
          Disciplina, evolução constante e excelência. Agende agora sua experiência na BRN Barbearia em Jundiaí.
        </p>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noreferrer"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-cream text-[#0b0807] px-7 py-3 text-sm font-medium hover:bg-white transition-colors"
        >
          <span className="w-2 h-2 rounded-full bg-[#0b0807]" />
          Falar no WhatsApp
        </a>
      </div>
    </section>
  );
};

export default Contact;
